module.exports = __webpack_public_path__ + "static/media/chomley 8.f907dd4d.jpg";